var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import NoticeContainer from '../Message/MessageContainer';
import Message from '../Message/Message';
import React from 'react';
import { defaultProps } from './defaults';
import classNames from 'classnames';
import { InfoOutlined, SuccessOutlined, WarnOutlined, ErrorOutlined, } from '@feb-team/legao-icons-react';
import { SpanTag } from '../../Utils/AtomicTag';
var instance = {};
var noticeType = ['success', 'error', 'info', 'warning'];
function NoticeContent(_a) {
    var message = _a.message, icon = _a.icon, desc = _a.desc;
    if (icon && desc) {
        return (React.createElement(React.Fragment, null,
            icon,
            React.createElement("div", { className: "legao-notification__content" },
                React.createElement("div", { className: "legao-notification__message" }, message),
                React.createElement("br", null),
                React.createElement("div", { className: "legao-notification__desc" }, desc))));
    }
    else {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "legao-notification__message" },
                icon,
                message),
            desc && React.createElement("div", { className: "legao-notification__desc" }, desc)));
    }
}
var api = {
    key: 0,
    config: function (options) {
        if (options.duration) {
            defaultProps.duration = options.duration;
        }
        if (options.top) {
            Object.assign(defaultProps, { top: options.top });
        }
    },
    open: function (config, type) {
        var options = Object.assign({}, __assign({}, defaultProps), __assign({}, config));
        var placement = options.placement, message = options.message, top = options.top, onClose = options.onClose, description = options.description, bottom = options.bottom, rest = __rest(options, ["placement", "message", "top", "onClose", "description", "bottom"]);
        if (!instance[placement]) {
            NoticeContainer.newInstance({
                className: "fixed legao-notification-container  legao-notification--" + placement,
                style: { marginTop: top, marginBottom: bottom },
            }, function (noticeInstance) {
                instance[options.placement] = noticeInstance;
            });
        }
        var containerCls = [
            'relative',
            'w-px-480',
            'mt-px-16',
            'mr-px-24',
            'pl-px-24',
            'min-h-px-48',
            'leading-px-22',
            'font-medium',
            'text-gray-700',
            'bg-white',
            'shadow',
        ];
        var key = api.key++;
        var getTypeIcon = function (type, desc) {
            var commonClass = '';
            if (desc) {
                commonClass = 'legao-notification__icon--large';
            }
            else {
                commonClass = 'legao-notification__icon';
            }
            var icon = {
                info: (React.createElement(SpanTag, { atomics: ['mr-px-8', 'text-brand-600'], className: classNames(commonClass) },
                    React.createElement(InfoOutlined, null))),
                success: (React.createElement(SpanTag, { atomics: ['mr-px-8', 'text-succ-900'], className: classNames(commonClass) },
                    React.createElement(SuccessOutlined, null))),
                warning: (React.createElement(SpanTag, { atomics: ['mr-px-8', 'text-warn-900'], className: classNames(commonClass) },
                    React.createElement(WarnOutlined, null))),
                error: (React.createElement(SpanTag, { atomics: ['mr-px-8', 'text-error-900'], className: classNames(commonClass) },
                    React.createElement(ErrorOutlined, null))),
            };
            return icon[type];
        };
        var icon = getTypeIcon(type, options.description);
        if (icon && options.description) {
            containerCls.push('pb-px-24', 'pt-px-24');
        }
        else {
            containerCls.push('pb-px-16', 'pt-px-16');
        }
        if (['bottom-left', 'bottom-right'].includes(placement)) {
            containerCls.push('mb-px-24');
        }
        var notification = (React.createElement(Message, __assign({}, rest, { noticeKey: key, startAnimation: "legao-notification-in--" + placement, closeAnimation: "legao-notification-out--" + placement, prefixCls: "notification", atomics: containerCls, onClose: function (key) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
                instance[placement].removeNotice(key);
            } }),
            React.createElement(NoticeContent, { message: message, desc: description, icon: icon })));
        var mesagecontent = { key: key, content: notification };
        instance[options.placement].notice(mesagecontent);
    },
};
noticeType.forEach(function (type) {
    var _a;
    Object.assign(api, (_a = {},
        _a[type] = function (config) {
            api.open(config, type);
        },
        _a));
});
export { api as notification };
